// // src/pages/Login.jsx
// import React, { useState } from 'react';
// import apiClient from 'apiClient';

// const LoginForm = ({ onLogin }) => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [message,  setMessage]  = useState('');
//   const [loading,  setLoading]  = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (loading) return;
//     setLoading(true);
//     setMessage('');

//     try {
//       const res = await apiClient.post(
//         '/auth/login',
//         { username, password },
//         { withCredentials: true }
//       );

//       // Inform App.js (not strictly required when we hard-redirect, but nice for SPA mode)
//       if (typeof onLogin === 'function') onLogin(res?.data?.userID);

//       setMessage('Login successful!');

//       // IMPORTANT: Force navigation so we definitely see /welcome.
//       // This avoids timing issues where route guards re-render before navigate() runs.
//       window.location.assign('/welcome');
//     } catch (err) {
//       const apiMsg = err?.response?.data?.error;
//       setMessage(apiMsg || 'Login failed. Please check your credentials and try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <h2>Login</h2>
//       <form onSubmit={handleSubmit}>
//         <input
//           type="text"
//           placeholder="Username"
//           value={username}
//           onChange={(e) => setUsername(e.target.value)}
//           style={styles.input}
//           required
//           autoComplete="username"
//         />
//         <input
//           type="password"
//           placeholder="Password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           style={styles.input}
//           required
//           autoComplete="current-password"
//         />
//         <button type="submit" style={styles.button} disabled={loading}>
//           {loading ? 'Logging inÃ¢â‚¬Â¦' : 'Login'}
//         </button>
//       </form>
//       {message && <p style={{ marginTop: 10 }}>{message}</p>}
//     </div>
//   );
// };

// const styles = {
//   container: {
//     maxWidth: '400px',
//     margin: '40px auto',
//     padding: '20px',
//     backgroundColor: '#f9f9f9',
//     borderRadius: '10px',
//     boxShadow: '0 0 10px rgba(0,0,0,0.1)',
//     textAlign: 'center',
//   },
//   input: {
//     width: '100%',
//     padding: '10px',
//     margin: '10px 0',
//     fontSize: '16px',
//     borderRadius: '5px',
//     border: '1px solid #ccc',
//   },
//   button: {
//     width: '100%',
//     padding: '12px',
//     backgroundColor: '#2196f3',
//     color: '#fff',
//     border: 'none',
//     fontSize: '16px',
//     borderRadius: '5px',
//     cursor: 'pointer',
//   },
// };

// export default LoginForm;







import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import apiClient from "../config/api";
import "../styles/Login.css";
import dallasImg from "../assets/Dallas.png";


export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const previousBodyOverflow = document.body.style.overflow;
    const previousRootOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousRootOverflow;
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setMessage("");
    setError(false);

    try {
      const res = await apiClient.post(
        "/auth/login",
        { username, password },
        { withCredentials: true }
      );
      if (typeof onLogin === "function") onLogin(res?.data?.userID);
      window.location.assign("/welcome");
    } catch (err) {
      const apiMsg = err?.response?.data?.error;
      setMessage(apiMsg || "Invalid username or password");
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      className="login-hero"
      style={{
        ["--bg-url"]:
          // 'url("https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=2400&q=80")',
          `url(${dallasImg})`
      }}
    >
      <div className="login-card-wrapper">
        <section className="login-card" aria-labelledby="login-title">
        <h1 id="login-title" className="brand-title">
          Thomas Y. Pickett
        </h1>

        <form className="form" onSubmit={handleSubmit}>
          <div className="field">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              name="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
            />
          </div>

          <div className="field">
            <label htmlFor="password">Password</label>
            <div className="with-toggle">
              <input
                id="password"
                name="password"
                type={showPw ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                className="toggle"
                aria-label={showPw ? "Hide password" : "Show password"}
                aria-pressed={showPw}
                onClick={() => setShowPw((v) => !v)}
              >
                {showPw ? (
                  <svg viewBox="0 0 24 24" width="22" height="22">
                    <path
                      d="M2 2l20 20M9.9 4.24A10.7 10.7 0 0122 12s-3.5 6.5-10 6.5a10 10 0 01-3.5-.64M6.2 6.2A10.7 10.7 0 002 12s3.5 6.5 10 6.5a10.3 10.3 0 002.2-.24M9.5 9.5a3.5 3.5 0 104.95 4.95"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" width="22" height="22">
                    <path
                      d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <circle
                      cx="12"
                      cy="12"
                      r="3"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>

          <button
            className="submit"
            type="submit"
            disabled={loading}
            aria-disabled={loading}
          >
            {loading ? "Logging ..." : "Login"}
          </button>

          <div className="aux">
            <Link to="/forgot-password" className="link">
              Forgot password?
            </Link>
          </div>

          <div className="aux">
            <Link to="/register" className="link">
              Create account
            </Link>
          </div>
        </form>

        {message && (
          <p
            role="alert"
            className={`status ${error ? "error" : "ok"}`}
            style={{ marginTop: "12px" }}
          >
            {message}
          </p>
        )}
        </section>
      </div>

      <p className="login-footer">
        Thomas Y. Pickett &mdash; &copy; 2025 copyright
      </p>
    </main>
  );
}
